import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=47355518&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "navbar.vue"
export default component.exports